import { ApiIQuestion } from "../../domain/election";
import { QuestionValidationResult } from "../types";
import { REFEREDUM_VALUE } from "./types";

export const yesnoValidate = (ballot: ApiIQuestion, vote: any): QuestionValidationResult => {
    if (vote === REFEREDUM_VALUE.YES || vote === REFEREDUM_VALUE.NO) {
        return { valid: true, empty: false }
    }
    return { valid: true, empty: true }
}